<template>
  <div ref="page" class="immokey">
    <legend-immokey></legend-immokey>
    <base-form
      ref="form"
      class="search-bar"
      v-model="toolbar.data"
      :form-items="toolbar.formItems"
      label-width="auto"
      input-trim
      inline
    ></base-form>
    <base-table-lite
      ref="table"
      url="view/getImmokeyData"
      :columns="columns"
      :init-search="false"
      @loaded="tableLoaded"
    ></base-table-lite>
  </div>
</template>

<script>
export default {
  name: 'immokey',
  data() {
    var currentLang = this.$root.getCurrentLang()
    return {
      defaultSearchField: [
        'year',
        'series',
        'key_type',
        'immo_type',
        'chassis',
        'area',
        'model',
        'system',
        'system_type'
      ],
      currentLang,
      currentLangLowerCase: currentLang.toLowerCase(),
      currentBrand: '',
      toolbar: {
        formItems: [
          {
            label: currentLang == 'CN' ? '产品' : 'Product',
            prop: 'product',
            component: 'product-select',
            bind: {
              lang: currentLang,
              category: 'immokey',
              profile: this.$route.query.configName
            },
            on: {
              productChange: (product) => {
                this.$nextTick(() => {
                  this.toolbar.formItems[1].bind.profile = product.profile
                })
              }
            }
          },
          {
            label: currentLang == 'CN' ? '品牌' : 'Brand',
            prop: 'pack_brand',
            component: 'brand-select',
            bind: { lang: currentLang, category: 'immokey', profile: '' },
            on: {
              outVersion: (option, versions) => {
                const { profile, brand, packid, version } = option
                const queryObj = { profile, brand, packid, version }
                this.toolbar.query.packid = option.packid
                this.toolbar.query.brand = JSON.stringify({
                  Field: 'brand',
                  ComparePattern: 'EQ',
                  Values: [option.brand]
                })
                this.$nextTick(() => {
                  const formItemVersion = this.toolbar.formItems[2]
                  formItemVersion.bind.queryObj = queryObj
                  formItemVersion.bind.version = versions
                })
              }
            }
          },
          {
            label: currentLang == 'CN' ? '版本' : 'Version',
            prop: 'version',
            component: 'version-select',
            bind: { version: [], queryObj: {} },
            on: {
              change: (newVal) => {
                this.$nextTick(() => {
                  this.getImmokeyField()
                })
              }
            }
          }
        ],
        data: {},
        query: {
          packid: null,
          brand: ''
        }
      },
      columns: []
    }
  },
  created() {
    this.$root.autoSetCurrentLang()
  },
  computed: {
    table() {
      return this.$refs.table
    },
    form() {
      return this.$refs.form
    }
  },
  methods: {
    getImmokeyField() {
      var searchData = this.toolbar.data
      //console.log(searchData)
      this.$post('view/getImmokeyField', {
        packid: this.toolbar.query.packid,
        version: searchData.version,
        lang: this.currentLang
      })
        .then((resp) => {
          if (resp.data.code == 0) {
            var columns = []
            var searchFieldFormItems = []
            this.initToolbarFormItems()
            var fieldIndex = 0
            for (var item of resp.data.data) {
              //过滤不显示的列
              if (['brand', 'version'].indexOf(item.field) > -1) {
                continue
              }
              var column = {
                bind: {
                  label: item[this.currentLang.toLowerCase()],
                  prop: item.field
                }
              }
              //用对应组件渲染显示数据类型
              if (item.data_type) {
                column.default = {
                  component: item.data_type.replace('|', ''),
                  bind: { lang: this.currentLang }
                }
              }
              columns.push(column)

              if (this.defaultSearchField.indexOf(item.field) > -1) {
                searchFieldFormItems.push({
                  label: item[this.currentLang.toLowerCase()],
                  prop: item.field,
                  component: 'field-select',
                  bind: {
                    fieldIndex: fieldIndex,
                    category: 'immokey',
                    field: item.field,
                    lang: this.currentLang,
                    packid: this.toolbar.query.packid,
                    version: searchData.version,
                    brand: this.currentBrand
                  },
                  on: {
                    valchange: (index, val) => {
                      this.resetSearchFieldBeginBy(index, val)
                      this.tableSearch()
                    }
                  }
                })
                fieldIndex++
              }
            }
            this.columns = columns
            this.$nextTick(() => {
              for (var item of searchFieldFormItems) {
                this.toolbar.formItems.push(item)
              }
              //第一个动态查询条件框价值初始化option
              this.firstSearchFieldInit()
              this.tableSearch()
            })
          } else {
            this.$message(resp.data.msg || '获取数据失败')
          }
        })
        .catch((error) => {
          console.error(error)
          this.$message('请求发生错误=>' + error)
        })
    },
    initToolbarFormItems() {
      if (this.toolbar.formItems.length > 3) {
        //找出多余的prop
        var props = []
        for (var i = 3; i < this.toolbar.formItems.length; i++) {
          props.push(this.toolbar.formItems[i].prop)
        }
        this.toolbar.formItems.splice(3)
        //删除多余的prop
        for (var prop of props) {
          this.$delete(this.toolbar.data, prop)
        }
      }
    },
    getSearchData() {
      var searchData = Object.assign({}, this.toolbar.data, this.toolbar.query)
      for (var field of this.defaultSearchField) {
        if (searchData[field]) {
          searchData[field] = JSON.stringify({
            Field: field,
            ComparePattern: 'EQ',
            Values: [searchData[field]]
          })
        }
      }
      return searchData
    },
    tableSearch() {
      this.table.table.doLayout()
      this.$nextTick(() => {
        this.table.searchData = this.getSearchData()
        this.table.searchData.lang = this.currentLang
        this.table.query.PageIndex = 1
        this.table.refreshData()
      })
    },
    tableLoaded() {
      window.parent.postMessage(
        {
          callback: 'setIframeHeight',
          args: [this.$refs.page.scrollHeight + 50]
        },
        '*'
      )
    },
    firstSearchFieldInit() {
      this.$nextTick(() => {
        var searchData = this.getSearchData()
        for (var item of this.$refs.form.items) {
          if (item.fieldIndex == 0) {
            item.getFieldOptions(searchData)
            break
          }
        }
      })
    },
    resetSearchFieldBeginBy(index, val) {
      var searchData = this.getSearchData()
      for (var item of this.$refs.form.items) {
        if (item.fieldIndex > index) {
          item.reset()
          if (val && item.fieldIndex == index + 1) {
            item.getFieldOptions(searchData)
          }
        }
      }
    }
  }
}
</script>
<style lang="less">
.immokey {
}
</style>
